import type { Question, QuestionStimulus, QuestionType } from '@examflow/core';

/**
 * DELE 考试等级 (基于 CEFR 标准)
 */
export enum DELELevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
}

/**
 * DELE 考试部分
 */
export enum DELESection {
  /** 阅读理解 */
  READING = 'reading',
  /** 听力理解 */
  LISTENING = 'listening',
  /** 书面表达 */
  WRITING = 'writing',
  /** 口语表达 */
  SPEAKING = 'speaking',
}

/**
 * DELE 题目扩展接口
 */
export interface DELEQuestion extends Question {
  /** 对应的 DELE 等级 */
  deleLevel?: DELELevel;
  /** 所属考试部分 */
  section?: DELESection;
  /** 题目序号（在该部分中） */
  orderInSection?: number;
}

/**
 * DELE 听力题目（single_choice + audio stimulus）
 */
export interface DELEListeningQuestion extends DELEQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'audio'>[];
  /** 音频URL */
  audioUrl: string;
  /** 音频播放次数限制 */
  maxPlayCount?: number;
  /** 音频时长（秒） */
  audioDuration?: number;
}

/**
 * DELE 阅读题目（single_choice + passage stimulus）
 */
export interface DELEReadingQuestion extends DELEQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'passage'>[];
  /** 阅读材料 */
  passage: string;
  /** 材料来源 */
  source?: string;
}

/**
 * DELE 分数与等级对照表
 */
export interface DELEScoreMapping {
  level: DELELevel;
  minScore: number;
  maxScore: number;
  cefrEquivalent: string;
  description: string;
}

/**
 * DELE 考试结果
 */
export interface DELEResult {
  /** 总分 */
  totalScore: number;
  /** 等级 */
  level: DELELevel;
  /** 各部分得分 */
  sectionScores: Record<DELESection, number>;
  /** 及格 */
  passed: boolean;
  /** 详细评价 */
  evaluation: string;
}
